/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Typography } from '@mui/material';
import { FxButton } from '../Action/FxButton';
import { ReactComponent as DefaultImage } from '../../../src/assets/svg/congratulation-image.svg';

interface IFxCongratulationsCard {
  message?: string;
  buttonText: string;
  onButtonClick?: (event: any) => void;
  Image?: React.ComponentType;
  className?: any;
  isPartner?:boolean
}

/** 
 * Component used to display image and content in split screen with full width
 * used to display congratulations card for partner
 */

export const FxCongratulations: React.FC<IFxCongratulationsCard> = React.memo(({
                                                                                 message,
                                                                                 Image,
                                                                                 buttonText,
                                                                                 onButtonClick,
                                                                                 className,
                                                                                 isPartner
                                                                               }) => {

  return (
    <Grid xs={12} container justifyContent={'center'} className={`fx-congratulation ${className ? className : ''}`}>
      <Grid item xs={12} container justifyContent={'center'} className={'fx-congratulation-image'}>
        {Image ? <Image /> : <DefaultImage />}
      </Grid>
      <Grid item xs={12} textAlign={'center'} className={'fx-congratulation-title'}>Congratulations!</Grid>
      {!isPartner&&message &&
          <Grid item xs={12} className={'fx-congratulation-message'}>
            {message}
          </Grid>
      }
      {isPartner &&
        <Grid className='fx-congratulation-message'>
         <Typography>You have full access to your Leads Portal, where you can:</Typography>
         <Grid>
         <Typography>• View potential leads</Typography>
         <Typography>• Send referral invitations</Typography>
         </Grid>
         <Typography>Start connecting and growing with Passport!</Typography>
        </Grid>}
      
      <FxButton id={'congratulations-button'} variant={'contained'} onClick={onButtonClick} className={`fx-button-theme`}>
        {buttonText}
      </FxButton>
    </Grid>
  )
})